export type VocabKey =
  | 'ticket' | 'tickets'
  | 'client' | 'clients'
  | 'technician' | 'technicians'
  | 'asset' | 'assets'
  | 'contract' | 'contracts'
  | 'proposal' | 'proposals'
  | 'part' | 'parts'
  | 'time_entry' | 'time_entries'
  | 'project' | 'projects'
  | 'dispatch' | 'notes' | 'dashboard';

export type IndustryVertical =
  | 'msp' | 'landscaping' | 'hvac' | 'plumbing' | 'electrical'
  | 'pest_control' | 'pool_spa' | 'security' | 'fire_protection'
  | 'elevator' | 'property_mgmt' | 'cleaning' | 'kitchen_equipment'
  | 'legal' | 'home_health' | 'veterinary' | 'financial_advisory' | 'construction'
  | 'marketing_agency' | 'pr_firm' | 'design_studio' | 'advertising_agency'
  | 'web_agency' | 'seo_content_agency' | 'video_production'
  | 'photography_studio' | 'branding_agency' | 'event_management';

export const VOCABULARY: Record<IndustryVertical, Record<VocabKey, string>> = {
  msp: {
    ticket: 'Ticket', tickets: 'Tickets',
    client: 'Client', clients: 'Clients',
    technician: 'Technician', technicians: 'Technicians',
    asset: 'Asset', assets: 'Assets',
    contract: 'Contract', contracts: 'Contracts',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Part', parts: 'Parts',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Notes', dashboard: 'Dashboard',
  },
  landscaping: {
    ticket: 'Work Order', tickets: 'Work Orders',
    client: 'Client', clients: 'Clients',
    technician: 'Crew Member', technicians: 'Crew',
    asset: 'Equipment', assets: 'Equipment',
    contract: 'Agreement', contracts: 'Agreements',
    proposal: 'Estimate', proposals: 'Estimates',
    part: 'Supply', parts: 'Supplies',
    time_entry: 'Time Log', time_entries: 'Time Log',
    project: 'Project', projects: 'Projects',
    dispatch: 'Scheduling', notes: 'Job Notes', dashboard: 'Dashboard',
  },
  hvac: {
    ticket: 'Service Call', tickets: 'Service Calls',
    client: 'Customer', clients: 'Customers',
    technician: 'Technician', technicians: 'Technicians',
    asset: 'Unit', assets: 'Units',
    contract: 'Service Contract', contracts: 'Service Contracts',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Part', parts: 'Parts',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  plumbing: {
    ticket: 'Service Call', tickets: 'Service Calls',
    client: 'Customer', clients: 'Customers',
    technician: 'Plumber', technicians: 'Plumbers',
    asset: 'Fixture', assets: 'Fixtures',
    contract: 'Service Contract', contracts: 'Service Contracts',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Part', parts: 'Parts',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  electrical: {
    ticket: 'Service Call', tickets: 'Service Calls',
    client: 'Customer', clients: 'Customers',
    technician: 'Electrician', technicians: 'Electricians',
    asset: 'Panel', assets: 'Panels',
    contract: 'Service Contract', contracts: 'Service Contracts',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Part', parts: 'Parts',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  pest_control: {
    ticket: 'Service Order', tickets: 'Service Orders',
    client: 'Customer', clients: 'Customers',
    technician: 'Technician', technicians: 'Technicians',
    asset: 'Site', assets: 'Sites',
    contract: 'Service Agreement', contracts: 'Service Agreements',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Product', parts: 'Products',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Routing', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  pool_spa: {
    ticket: 'Service Call', tickets: 'Service Calls',
    client: 'Client', clients: 'Clients',
    technician: 'Technician', technicians: 'Technicians',
    asset: 'Pool', assets: 'Pools',
    contract: 'Service Agreement', contracts: 'Service Agreements',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Chemical', parts: 'Chemicals',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Routing', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  security: {
    ticket: 'Work Order', tickets: 'Work Orders',
    client: 'Client', clients: 'Clients',
    technician: 'Technician', technicians: 'Technicians',
    asset: 'System', assets: 'Systems',
    contract: 'Service Contract', contracts: 'Service Contracts',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Part', parts: 'Parts',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  fire_protection: {
    ticket: 'Inspection', tickets: 'Inspections',
    client: 'Client', clients: 'Clients',
    technician: 'Inspector', technicians: 'Inspectors',
    asset: 'System', assets: 'Systems',
    contract: 'Service Contract', contracts: 'Service Contracts',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Part', parts: 'Parts',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Inspection Notes', dashboard: 'Dashboard',
  },
  elevator: {
    ticket: 'Maintenance Order', tickets: 'Maintenance Orders',
    client: 'Client', clients: 'Clients',
    technician: 'Mechanic', technicians: 'Mechanics',
    asset: 'Elevator', assets: 'Elevators',
    contract: 'Maintenance Contract', contracts: 'Maintenance Contracts',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Part', parts: 'Parts',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  property_mgmt: {
    ticket: 'Work Order', tickets: 'Work Orders',
    client: 'Tenant', clients: 'Tenants',
    technician: 'Maintenance Tech', technicians: 'Maintenance Staff',
    asset: 'Property', assets: 'Properties',
    contract: 'Lease', contracts: 'Leases',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Supply', parts: 'Supplies',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Scheduling', notes: 'Work Notes', dashboard: 'Dashboard',
  },
  cleaning: {
    ticket: 'Service Order', tickets: 'Service Orders',
    client: 'Client', clients: 'Clients',
    technician: 'Cleaner', technicians: 'Cleaners',
    asset: 'Location', assets: 'Locations',
    contract: 'Service Agreement', contracts: 'Service Agreements',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Supply', parts: 'Supplies',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Scheduling', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  kitchen_equipment: {
    ticket: 'Service Call', tickets: 'Service Calls',
    client: 'Client', clients: 'Clients',
    technician: 'Technician', technicians: 'Technicians',
    asset: 'Equipment', assets: 'Equipment',
    contract: 'Service Contract', contracts: 'Service Contracts',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Part', parts: 'Parts',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Service Notes', dashboard: 'Dashboard',
  },
  legal: {
    ticket: 'Matter', tickets: 'Matters',
    client: 'Client', clients: 'Clients',
    technician: 'Associate', technicians: 'Associates',
    asset: 'Case File', assets: 'Case Files',
    contract: 'Retainer', contracts: 'Retainers',
    proposal: 'Engagement Letter', proposals: 'Engagement Letters',
    part: 'Disbursement', parts: 'Disbursements',
    time_entry: 'Billable Hours', time_entries: 'Billable Hours',
    project: 'Matter', projects: 'Matters',
    dispatch: 'Scheduling', notes: 'Case Notes', dashboard: 'Matter Board',
  },
  home_health: {
    ticket: 'Case', tickets: 'Cases',
    client: 'Patient', clients: 'Patients',
    technician: 'Caregiver', technicians: 'Caregivers',
    asset: 'Equipment', assets: 'Equipment',
    contract: 'Care Plan', contracts: 'Care Plans',
    proposal: 'Care Plan', proposals: 'Care Plans',
    part: 'Supply', parts: 'Supplies',
    time_entry: 'Service Time', time_entries: 'Service Records',
    project: 'Care Plan', projects: 'Care Plans',
    dispatch: 'Scheduling', notes: 'Care Notes', dashboard: 'Care Board',
  },
  veterinary: {
    ticket: 'Case', tickets: 'Cases',
    client: 'Client', clients: 'Clients',
    technician: 'Technician', technicians: 'Technicians',
    asset: 'Patient', assets: 'Patients',
    contract: 'Care Plan', contracts: 'Care Plans',
    proposal: 'Treatment Plan', proposals: 'Treatment Plans',
    part: 'Supply', parts: 'Supplies',
    time_entry: 'Service Time', time_entries: 'Service Records',
    project: 'Treatment', projects: 'Treatments',
    dispatch: 'Scheduling', notes: 'Clinical Notes', dashboard: 'Patient Board',
  },
  financial_advisory: {
    ticket: 'Engagement', tickets: 'Engagements',
    client: 'Client', clients: 'Clients',
    technician: 'Advisor', technicians: 'Advisors',
    asset: 'Account', assets: 'Accounts',
    contract: 'Advisory Agreement', contracts: 'Advisory Agreements',
    proposal: 'Proposal', proposals: 'Proposals',
    part: '—', parts: '—',
    time_entry: 'Billable Hours', time_entries: 'Billable Hours',
    project: 'Engagement', projects: 'Engagements',
    dispatch: 'Scheduling', notes: 'Advisor Notes', dashboard: 'Portfolio',
  },
  construction: {
    ticket: 'Work Order', tickets: 'Work Orders',
    client: 'Owner', clients: 'Owners',
    technician: 'Tradesperson', technicians: 'Tradespeople',
    asset: 'Equipment', assets: 'Equipment',
    contract: 'Contract', contracts: 'Contracts',
    proposal: 'Bid', proposals: 'Bids',
    part: 'Material', parts: 'Materials',
    time_entry: 'Labor', time_entries: 'Labor Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Dispatch', notes: 'Field Notes', dashboard: 'Dashboard',
  },
  marketing_agency: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Strategist', technicians: 'Strategists',
    asset: 'Brand', assets: 'Brands',
    contract: 'Retainer', contracts: 'Retainers',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Media & Ad Spend', parts: 'Media & Ad Spend',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Campaign', projects: 'Campaigns',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  pr_firm: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Publicist', technicians: 'Publicists',
    asset: 'Brand', assets: 'Brands',
    contract: 'Retainer', contracts: 'Retainers',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Placement Costs', parts: 'Placement Costs',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Campaign', projects: 'Campaigns',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  design_studio: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Designer', technicians: 'Designers',
    asset: 'Brand', assets: 'Brands',
    contract: 'Retainer', contracts: 'Retainers',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Print & Production', parts: 'Print & Production',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Project', projects: 'Projects',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  advertising_agency: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Creative', technicians: 'Creatives',
    asset: 'Brand', assets: 'Brands',
    contract: 'Retainer', contracts: 'Retainers',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Media Buy', parts: 'Media Buy',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Campaign', projects: 'Campaigns',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  web_agency: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Developer', technicians: 'Developers',
    asset: 'Website', assets: 'Websites',
    contract: 'Care Plan', contracts: 'Care Plans',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Licences & Hosting', parts: 'Licences & Hosting',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Build', projects: 'Builds',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  seo_content_agency: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Specialist', technicians: 'Specialists',
    asset: 'Property', assets: 'Properties',
    contract: 'Retainer', contracts: 'Retainers',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Tools & Placements', parts: 'Tools & Placements',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Engagement', projects: 'Engagements',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  video_production: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Producer', technicians: 'Producers',
    asset: 'Location', assets: 'Locations',
    contract: 'Project Agreement', contracts: 'Project Agreements',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Equipment & Crew', parts: 'Equipment & Crew',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Production', projects: 'Productions',
    dispatch: 'Call Sheet', notes: 'Notes', dashboard: 'Dashboard',
  },
  photography_studio: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Photographer', technicians: 'Photographers',
    asset: 'Location', assets: 'Locations',
    contract: 'Package', contracts: 'Packages',
    proposal: 'Quote', proposals: 'Quotes',
    part: 'Prints & Products', parts: 'Prints & Products',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Shoot', projects: 'Shoots',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  branding_agency: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Strategist', technicians: 'Strategists',
    asset: 'Brand', assets: 'Brands',
    contract: 'Retainer', contracts: 'Retainers',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Production', parts: 'Production',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Engagement', projects: 'Engagements',
    dispatch: 'Scheduling', notes: 'Notes', dashboard: 'Dashboard',
  },
  event_management: {
    ticket: 'Request', tickets: 'Requests',
    client: 'Client', clients: 'Clients',
    technician: 'Coordinator', technicians: 'Coordinators',
    asset: 'Venue', assets: 'Venues',
    contract: 'Event Agreement', contracts: 'Event Agreements',
    proposal: 'Proposal', proposals: 'Proposals',
    part: 'Vendors & Rentals', parts: 'Vendors & Rentals',
    time_entry: 'Time Entry', time_entries: 'Time Entries',
    project: 'Event', projects: 'Events',
    dispatch: 'Run of Show', notes: 'Notes', dashboard: 'Dashboard',
  },
};

export function getVocab(
  vertical: string | null | undefined,
  key: VocabKey,
  overrides?: Record<string, string>,
): string {
  if (overrides?.[key]) return overrides[key];
  const v = (vertical ?? 'msp') as IndustryVertical;
  return VOCABULARY[v]?.[key] ?? VOCABULARY['msp'][key];
}
